import template from './analytics-users.html';
import controller from './analytics-users.controller';
import './analytics-users.styl';

let analyticsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default analyticsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-users/analytics-users.component.js
 **/